export function getMyUnreadEmailsItemProps(value) {
  return {
    accountType: value.access_type,
    text: value.email,
    unread: value.unread,
    value: value.id,
  }
}
